import { Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { SchemasFactory, ContentFactory } from '../../squidex';
import { AppToken } from '../../../models/app-token';

@Injectable({
  providedIn: 'root'
})
export class SchemaPageService extends BaseService {

  constructor(schemasFactory: SchemasFactory,
    contentFactory: ContentFactory) {
    super(AppToken.SCHEMA_PAGE_SCHEMA_NAME, contentFactory);
  }
}
